export enum ACLResourceType {
    ASSET_IMAGE = "ASSET_IMAGE",
    ASSET_AUDIO = "ASSET_AUDIO",
    ASSET_VIDEO = "ASSET_VIDEO",
    BACKGROUND = "BACKGROUND",
    WIDEO = "WIDEO",
    USER_SCENE = "USER_SCENE"
}